export const HUMAN_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm' // Based on date-fns pattern
export const HUMAN_MONTH_DATE_TIME_FORMAT = 'MM/yyyy HH:mm' // Based on date-fns pattern
